import script from "./RoleModify.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleModify.vue?vue&type=script&setup=true&lang=js"

import "./RoleModify.vue?vue&type=style&index=0&id=6bc6dde2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bc6dde2"]])

export default __exports__